'use client';

import { useTranslations } from 'next-intl';

import { MappedProduct } from '@/fo/util/map-product-data';

import { styles } from './UiProductInfoGroupedComposition.styles';

export interface UiProductInfoGroupedCompositionProps {
  products: MappedProduct[];
  className?: string;
  children?: React.ReactNode;
}

export function UiProductInfoGroupedComposition({
  className,
  children
}: UiProductInfoGroupedCompositionProps) {
  const t = useTranslations();
  const slots = styles();

  return (
    <section className={slots.base({ className })}>
      <h2 className={slots.title()}>{t('product.grouped.composition')}</h2>
      <div className={slots.products()}>{children}</div>
    </section>
  );
}
